import { render, staticRenderFns } from "./ingredientV2Widget.vue?vue&type=template&id=31902ab5&scoped=true&"
import script from "./ingredientV2Widget.vue?vue&type=script&lang=js&"
export * from "./ingredientV2Widget.vue?vue&type=script&lang=js&"
import style0 from "./ingredientV2Widget.vue?vue&type=style&index=0&id=31902ab5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31902ab5",
  null
  
)

export default component.exports